export const PAY_RATE_HISTORY_ENDPOINT = `${process.env.REACT_APP_API_URL}/api/vault77/payRateHistory`;
